import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { AssetResolver } from '@app/core/resolvers/asset-resolver.service';
import { DocumentViewerComponent } from '@app/shared/components/document-viewer/document-viewer.component';
import { AuthGuard } from './core/guards/auth.guard';
import { canMatchAuth, canMatchDashboard } from './core/guards/can-match';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
    // canMatch: [canMatchAuth]
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    // canMatch: [canMatchDashboard],
    canActivate: [AuthGuard]
  },
  {
    path: 'document/:documentName',
    resolve: { asset: AssetResolver },
    component: DocumentViewerComponent
  },
  { path: '**', redirectTo: 'auth' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
